// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-icon{cursor:pointer;color:#6c757d}.action-icon:hover{opacity:.8}", ""]);
// Exports
module.exports = exports;
